import { Box, Typography, Container, Divider } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";

function Registry() {
  const titleRef = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const dividerRef = useRef(null);

  // Details section refs
  const detailsTitleRef = useRef(null);
  const ibanLabelRef = useRef(null);
  const ibanValueRef = useRef(null);
  const bicLabelRef = useRef(null);
  const bicValueRef = useRef(null);
  const mbwayLabelRef = useRef(null);
  const mbwayValue1Ref = useRef(null);
  const mbwayValue2Ref = useRef(null);
  const divider2Ref = useRef(null);

  // Gift ideas section refs
  const giftsTitleRef = useRef(null);

  const titleInView = useInView(titleRef, { once: true, margin: "0px" });
  const isInView1 = useInView(ref1, { once: true, margin: "0px" });
  const isInView2 = useInView(ref2, { once: true, margin: "0px" });
  const isInView3 = useInView(ref3, { once: true, margin: "0px" });
  const isInView4 = useInView(ref4, { once: true, margin: "0px" });
  const isInView5 = useInView(ref5, { once: true, margin: "0px" });
  const isInView6 = useInView(ref6, { once: true, margin: "0px" });
  const dividerInView = useInView(dividerRef, { once: true, margin: "0px" });

  // Details section views
  const detailsTitleInView = useInView(detailsTitleRef, {
    once: true,
    margin: "0px",
  });
  const ibanLabelInView = useInView(ibanLabelRef, {
    once: true,
    margin: "0px",
  });
  const ibanValueInView = useInView(ibanValueRef, {
    once: true,
    margin: "0px",
  });
  const bicLabelInView = useInView(bicLabelRef, { once: true, margin: "0px" });
  const bicValueInView = useInView(bicValueRef, { once: true, margin: "0px" });
  const mbwayLabelInView = useInView(mbwayLabelRef, {
    once: true,
    margin: "0px",
  });
  const mbwayValue1InView = useInView(mbwayValue1Ref, {
    once: true,
    margin: "0px",
  });
  const mbwayValue2InView = useInView(mbwayValue2Ref, {
    once: true,
    margin: "0px",
  });
  const divider2InView = useInView(divider2Ref, { once: true, margin: "0px" });

  // Gift ideas section views
  const giftsTitleInView = useInView(giftsTitleRef, {
    once: true,
    margin: "0px",
  });

  const { animationStarted } = useAnimation();

  return (
    <>
      <Box
        id="registry"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#faf4e9",
        }}
      >
        <Container maxWidth="md" sx={{ mt: 8 }}>
          {/* Title */}
          <Typography
            component={motion.h1}
            ref={titleRef}
            initial={{ opacity: 0, y: 40 }}
            animate={titleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="h1"
            sx={{
              fontFamily: '"Playfair Display", Georgia, serif',
              fontSize: { xs: "2.5rem", sm: "3.5rem" },
              fontWeight: 400,
              color: "#1a3a52",
              letterSpacing: "1px",
              mb: 6,
              textAlign: "center",
            }}
          >
            <Box
              component="span"
              sx={{ display: { xs: "inline", sm: "none" } }}
            >
              Lista <br />
              de Presentes
            </Box>
            <Box
              component="span"
              sx={{ display: { xs: "none", sm: "inline" } }}
            >
              Lista de Presentes
            </Box>
          </Typography>

          {/* Main Message */}
          <Box
            sx={{
              textAlign: "justify",
              px: { xs: 2, sm: 4, md: 6 },
              mb: 4,
            }}
          >
            <Typography
              component={motion.p}
              ref={ref1}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView1 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 2,
              }}
            >
              Querida Família e Queridos Amigos,
            </Typography>

            <Typography
              component={motion.p}
              ref={ref2}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 2,
              }}
            >
              A vossa presença no nosso tão especial dia é o mais importante
              para nós.
            </Typography>

            <Typography
              component={motion.p}
              ref={ref3}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView3 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 2,
              }}
            >
              Ainda assim, se desejarem oferecer-nos um presente, partilhamos o
              nosso IBAN para contribuírem para a nossa Lua de Mel ou se
              quiserem ajudar na decoração da nossa casa. Pedimos que coloquem o
              nome na transferência para vos podermos agradecer posteriormente.
            </Typography>

            <Typography
              component={motion.p}
              ref={ref4}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView4 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 2,
              }}
            >
              Qualquer contributo será recebido com enorme amor e gratidão.
            </Typography>

            <Typography
              component={motion.p}
              ref={ref5}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 2,
              }}
            >
              Muito obrigado por fazerem parte da nossa história e estamos
              ansiosos por partilhar o dia do nosso casamento convosco!
            </Typography>

            <Typography
              component={motion.p}
              ref={ref6}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView6 ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="body1"
              align="justify"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1rem", sm: "1.1rem" },
                lineHeight: 2,
                color: "#2d4e66",
                mb: 3,
              }}
            ></Typography>
          </Box>

          {/* Details Section */}
          <Box
            sx={{
              px: { xs: 2, sm: 4, md: 6 },
              mb: 4,
            }}
          >
            <Typography
              component={motion.h5}
              ref={detailsTitleRef}
              initial={{ opacity: 0, y: 30 }}
              animate={
                detailsTitleInView
                  ? { opacity: 1, y: 0 }
                  : { opacity: 0, y: 30 }
              }
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              variant="h5"
              align="center"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "1.35rem", sm: "1.5rem" },
                fontWeight: 400,
                color: "#1a3a52",
                mb: 3,
                letterSpacing: "0.5px",
              }}
            >
              Detalhes
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Typography
                component={motion.p}
                ref={ibanLabelRef}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  ibanLabelInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  fontWeight: 600,
                  color: "#1a3a52",
                  mb: 0.5,
                }}
              >
                IBAN:
              </Typography>
              <Typography
                component={motion.p}
                ref={ibanValueRef}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  ibanValueInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  color: "#2d4e66",
                  wordBreak: "break-all",
                }}
              >
                PT50026903910020623691294
              </Typography>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography
                component={motion.p}
                ref={bicLabelRef}
                initial={{ opacity: 0, y: 20 }}
                align="center"
                animate={
                  bicLabelInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  fontWeight: 600,
                  color: "#1a3a52",
                  mb: 0.5,
                }}
              >
                BIC/SWIFT:
              </Typography>
              <Typography
                component={motion.p}
                ref={bicValueRef}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  bicValueInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  color: "#2d4e66",
                }}
              >
                BKBKPTPL
              </Typography>
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography
                component={motion.p}
                ref={mbwayLabelRef}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  mbwayLabelInView
                    ? { opacity: 1, y: 0 }
                    : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  fontWeight: 600,
                  color: "#1a3a52",
                  mb: 1,
                }}
              >
                MBWAY:
              </Typography>
              <Typography
                component={motion.p}
                ref={mbwayValue1Ref}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  mbwayValue1InView
                    ? { opacity: 1, y: 0 }
                    : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  color: "#2d4e66",
                  mb: 0.5,
                }}
              >
                Isabela: +351 918 362 647
              </Typography>
              <Typography
                component={motion.p}
                ref={mbwayValue2Ref}
                initial={{ opacity: 0, y: 20 }}
                animate={
                  mbwayValue2InView
                    ? { opacity: 1, y: 0 }
                    : { opacity: 0, y: 20 }
                }
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
                variant="body1"
                align="center"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                  color: "#2d4e66",
                }}
              >
                Tiago: +351 914 287 652
              </Typography>
            </Box>
          </Box>

          {/* Gift Ideas Section */}
          {/* <Box
          sx={{
            px: { xs: 2, sm: 4, md: 6 },
          }}
        >
          <Typography
            component={motion.h5}
            ref={giftsTitleRef}
            initial={{ opacity: 0, y: 30 }}
            animate={
              giftsTitleInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
            }
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            variant="h5"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1.35rem", sm: "1.5rem" },
              fontWeight: 400,
              color: "#1a3a52",
              mb: 3,
              letterSpacing: "0.5px",
            }}
          >
            Ideias de Presentes
          </Typography>

          <Box
            component="ul"
            sx={{
              listStyle: "none",
              padding: 0,
              margin: 0,
            }}
          >
            {[
              "Fundo Lua de Mel",
              "Aspirador Dyson",
              "Cadeirão para a Sala de Estar",
              "Conjunto Vista Alegre",
              "Quadros (diria que vários)",
              "Máquina de lavar / secar roupa",
              "Ar condicionado",
              "Batedeira",
            ].map((gift, index) => (
              <Box
                component={motion.li}
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "0px" }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.08,
                  ease: [0.22, 1, 0.36, 1],
                }}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  mb: 1.5,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: { xs: "1rem", sm: "1.05rem" },
                    color: "#8b7355",
                    mr: 1.5,
                    fontWeight: 600,
                  }}
                >
                  •
                </Typography>
                <Typography
                  sx={{
                    fontFamily: '"Open Sans", sans-serif',
                    fontSize: { xs: "1rem", sm: "1.05rem" },
                    color: "#2d4e66",
                    lineHeight: 1.6,
                  }}
                >
                  {gift}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box> */}
        </Container>
      </Box>
      <Container maxWidth="md" sx={{ mt: 5 }}>
        <Divider
          component={motion.hr}
          ref={divider2Ref}
          initial={{ opacity: 0, scaleX: 0 }}
          animate={
            divider2InView && animationStarted
              ? { opacity: 0.3, scaleX: 1 }
              : { opacity: 0, scaleX: 0 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            my: 2,
            mx: { xs: 4, sm: 6, md: 8 },
            borderColor: "#8b7355",
          }}
        />
      </Container>
    </>
  );
}

export default Registry;
